import { z } from "zod";

export const UrlStringSchema = z.url().brand("UrlString");

export type UrlString = z.infer<typeof UrlStringSchema>;

export const UrlString = {
  unsafeCreate(value: string): UrlString {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Required for branded type construction
    return value as UrlString;
  },
} as const;
